/**
 * Texts for User Training page - German
 */
export const userTrainingPageText = {
    title: 'Benutzerschulung - CamAPS FX',
    titleMeta: 'Umfassende Schulungsressourcen für CamAPS FX-Benutzer',
    descriptionMeta: 'Zugriff auf vollständige Schulungsmaterialien, Video-Tutorials, Benutzerhandbücher und Webinare, um das Beste aus CamAPS FX herauszuholen.',
    keywords:
        'camaps fx benutzerschulung, camaps schulung, diabetes schulung, insulinpumpe schulung, benutzerhandbuch, video tutorials',
    localeMeta: 'de_de',

    mainHeader: 'Benutzerschulung',
    mainSubHeader: 'Schließen Sie die wichtige In-App-Schulung ab, bevor Sie die CamAPS FX-App verwenden.',

    gettingStartedHeader: 'Erste Schritte',
    step1Title: '<strong>Schritt 1:</strong><br/>Laden Sie die App herunter',
    step2Title: '<strong>Schritt 2:</strong><br/>Erstellen Sie ein Konto',
    step3Title: '<strong>Schritt 3:</strong><br/>Beginnen Sie mit der wichtigen In-App-Schulung',
    step4Title: '<strong>Schritt 4:</strong><br/>Koppeln Sie Ihre gewählte Pumpe und CGM (mit Zustimmung Ihres medizinischen Teams) oder erkunden Sie die App im <strong>virtuellen Modus</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Benötigen Sie Hilfe bei der Installation der App?',
    supportSectionText: 'Besuchen Sie unseren Support-Bereich für Anleitungen',
    supportButtonText: 'UNTERSTÜTZUNG',
    findOutMoreButtonText: 'MEHR ERFAHREN',

    additionalResourcesTitle: 'Zusätzliche Ressourcen',
    additionalResourcesSubtitle: 'Lernen Sie durch schrittweise Visualisierungen oder schauen Sie sich von Experten geleitete Sitzungen zur Verwendung der App an.',
    
    animationsTitle: 'Animationen',
    animationsDescription: 'Die Dana Insulinpumpe ist derzeit nur in Großbritannien kommerziell mit CamAPS FX erhältlich. Alle mit Dana zusammenhängenden Ressourcen sind daher nur auf Englisch verfügbar.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinare',
    webinarsDescription: 'Diese Webinare eignen sich für Menschen mit Typ-1-Diabetes, ihre Familie und Betreuer sowie für Lehrer, Mitarbeiter zur Unterstützung der Bildung und Angehörige der Gesundheitsberufe. Sie werden in englischer Sprache angeboten.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Informationsblätter',
    factsheetsDescription: 'Die Dana Insulinpumpe ist derzeit nur in Großbritannien kommerziell mit CamAPS FX erhältlich. Alle mit Dana zusammenhängenden Ressourcen sind daher nur auf Englisch verfügbar.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'In-App-Schulung',
    inAppTrainingText: 'Beginnen Sie mit der essentiellen Schulung, die in die CamAPS FX-App integriert ist. Diese interaktive Schulung führt Sie durch alle wichtigen Funktionen, die Sie kennen müssen.<br/><br/><strong>Zugriff:</strong> Laden Sie die CamAPS FX-App herunter und erstellen Sie ein Konto, um Ihre In-App-Schulung zu beginnen.',

    gettingStartedText: '<strong>Schritt 1:</strong> Laden Sie die CamAPS FX-App aus dem App Store Ihres Geräts herunter<br/><strong>Schritt 2:</strong> Erstellen Sie Ihr Konto<br/><strong>Schritt 3:</strong> Schließen Sie die In-App-Schulungsmodule ab<br/><strong>Schritt 4:</strong> Verbinden Sie Ihre Insulinpumpe und CGM<br/><strong>Schritt 5:</strong> Beginnen Sie Ihre CamAPS FX-Reise',

    trainingResourcesHeader: 'Zusätzliche Schulungsressourcen',
    videoTutorialsText: 'Video-Tutorials',
    videoTutorialsDesc: 'Sehen Sie sich Schritt-für-Schritt-Videoanleitungen zu Einrichtung, täglicher Nutzung und Fehlerbehebung an.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Benutzerhandbücher & Dokumentation',
    userGuidesDesc: 'Laden Sie umfassende PDF-Handbücher und Kurzreferenzmaterialien herunter.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Live-Webinare',
    webinarsDesc: 'Nehmen Sie an von Experten geleiteten Schulungssitzungen und Frage-und-Antwort-Möglichkeiten teil.',

    needHelpHeader: 'Benötigen Sie Hilfe?',
    needHelpTextStart: 'Wenn Sie Unterstützung benötigen oder Fragen haben, besuchen Sie unsere',
    supportLinkText: 'Support',
    needHelpTextEnd: 'Seite für zusätzliche Hilfe und Kontaktinformationen.'
};

